<template>
  <div class="uplodempa">
    <div class="uolodempa-btnkuang">
      <el-button ref="VideoChose" id="VideoChose" size="mini">
        <i class="el-icon-upload"></i>
        <div v-show="uptxt" class="mp4txt">
        <p>{{videtxtone}}</p>
        <p>{{videtxttwo}}</p>

        </div>

      </el-button>
      <!-- 进度条 -->
       <div v-show="upprogress" class="uplode-progressa">
     <el-table :data="fileList">
          <el-table-column  label="进度" v-slot="{ row }">
            <el-progress
              :text-inside="true"
              :stroke-width="16"
              :percentage="row.percentage"
            ></el-progress>
          </el-table-column>
           </el-table>
        </div>
    </div>
    <div class="uplodemp-btn-chuan">

    <!-- <el-button ref="VideoChose" type="primary" size="mini" @click="FileUplodeOn"
      >点击上传视频
      </el-button> -->
      <p class="upvdeo">上传视频</p>
      </div>



    <div class="tabuplode">
      <el-table :data="fileList">
        <!-- <el-table-column prop="id" label="文件id"></el-table-column>
        <el-table-column prop="name" label="文件名称"></el-table-column>
        <el-table-column prop="type" label="文件类型"></el-table-column>
        <el-table-column prop="size" label="文件大小" v-slot="{row}">
          {{row.size}}MB
        </el-table-column> -->
        <!-- <div class="uplode-progress">
          <el-table-column  label="进度" v-slot="{ row }">
            <el-progress
              :text-inside="true"
              :stroke-width="16"
              :percentage="row.percentage"
            ></el-progress>
          </el-table-column>
        </div> -->

        <el-table-column label="取消上传" v-slot="{ row }">
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            circle
            @click="removeFile(row.id)"
          ></el-button>
        </el-table-column>
        <el-table-column label="上传状态" v-slot="{ row }">
          <el-link
            :type="
              row.loadType == 0
                ? 'info'
                : row.loadType == 1
                ? 'warning'
                : row.loadType == 2
                ? 'success'
                : 'danger'
            "
            :underline="false"
            >{{
              row.loadType == 0
                ? "等待上传"
                : row.loadType == 1
                ? "正在上传"
                : row.loadType == 2
                ? "上传成功"
                : "上传失败"
            }}</el-link
          >
        </el-table-column>
      </el-table>
 </div>
  </div>
</template>

<script>
import plupload from "plupload";
import axios from "axios";
import uplodemp from "../css/UpLodemp.css";
import { Message,Loading } from 'element-ui';
export default {
  data() {
    return {
      show: false,
      fileList: [],
      fileOptions: {
        browse_button: "VideoChose",
        url: this.$apiUrl+"/index.php/teacher/uploadMp4",
        flash_swf_url: "script/Moxie.swf",
        silverlight_xap_url: "script/Moxie.xap",
        chunk_size: "2mb",
        max_retries: 1,
        unique_names: true,
        multi_selection: true,
        views: {
          list: true,
          thumbs: true, // Show thumbs
          active: "thumbs",
        },
        filters: {
          mime_types: [
            //文件格式
            {
              title: "movie files",
              extensions: "mp4", //文件格式
            },
          ],
          max_file_size: "250mb", //最大上传的文件
          prevent_duplicates: true, //不允许选取重复文件
        },
        multipart_params: {
          //uuid: "", //参数
          token: JSON.parse(localStorage.getItem("userinfo")).token,
        },
      },
      uplodetwomp:'',
      upprogress:false,
      uptxt:true,
      videtxtone:'请上传250M内',
      videtxttwo:'的MP4格式',
       lodingsa:''
    }
  },

  mounted() {
    //实例化一个plupload上传对象
    this.uploader.init();
    //绑定进队列
    this.uploader.bind("FilesAdded", this.FilesAdded);
    //绑定进度
    this.uploader.bind("UploadProgress", this.UploadProgress);
    //上传之前
    this.uploader.bind("BeforeUpload", this.BeforeUpload);
    //上传成功监听
    this.uploader.bind("FileUploaded", this.FileUploaded);

  },
  computed: {
    //实例化一个plupload上传对象
    uploader() {
      return new plupload.Uploader(this.fileOptions);
    },
  },
  methods: {
    //绑定进队列
    FilesAdded(uploader, files) {
      let objarr = files.map((val, ind) => {
        let obj = {};
        obj.id = val.id;
        obj.name = val.name;
        obj.type = val.type;
        obj.size = parseInt((val.origSize / 1024 / 1024) * 100) / 100;
        obj.percentage = 0;
        obj.loadType = 0;
        return obj;
      });
        if(uploader.files.length>1) { // 最多上传3张图
            // return alert("提示，只能上传一个文件，请删除多余文件！");
            uploader.files.splice(0, 1);
        }

        uploader.start();
            this.upprogress = true;
            this.uptxt = false;
            // this.fileList.push(...objarr);
            this.fileList = objarr;
            this.lodingsa =  Loading.service({
               lock:true,
               text:'视频上传中，请您耐心等待.....',
               spinner:'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
             });
      //   this.videtxtone = '请点击下方上传按钮'
      // this.videtxttwo = ' ';
    },
    //上传之前回调
    BeforeUpload(uploader, file) {
      this.fileList = this.fileList.map((val, ind) => {
        if (val.id == file.id) {
          val.loadType = 1;
        }
        return val;
      });

    },
    //上传进度回调
    UploadProgress(uploader, file) {
      this.fileList = this.fileList.map((val, ind) => {
        if (val.id == file.id) {
          val.percentage = file.percent;
        }
        return val;
      });
    },
    // 上传成功回调
    FileUploaded(uploader, file, responseObject) {
      this.fileList = this.fileList.map((val, ind) => {
        if (val.id == file.id) {
          if (JSON.parse(responseObject.response).status == 0) {
            val.loadType = 2;
          } else {
            val.loadType = 3;
          }
        }
        return val;
      });
      this.uplodetwomp = JSON.parse(responseObject.response).data.file_path;
      this.$emit('child-event',JSON.parse(responseObject.response).data);
      if (JSON.parse(responseObject.response).data.code == 2) {
        this.$message({
          message:'视频上传成功！！！',
          offset:200,
          type:'success'
        })
         this.upprogress = false;
         this.uptxt = true;
         this.videtxtone = '视频上传成功！！！'
         this.videtxttwo = ' ';
         this.lodingsa.close();
      }
      // console.log('这是视频',JSON.parse(responseObject.response).data.code);
    },

    //取消上传回调
    removeFile(id) {
      this.uploader.removeFile(id);
      this.fileList = this.fileList.filter((val, ind) => {
        if (val.id == id) {
          return false;
        } else {
          return true;
        }
      });
    },
    //开始上传
    FileUplodeOn() {
    // this.uploader.start();

       this.upprogress = true;
       this.uptxt = false;
    },
  },
};
</script>
<style>
.upvdeo{
  font-size: 0.18rem;
    font-weight: 500;
    color: #606060;
    line-height: 0.6rem;

}
</style>



// WEBPACK FOOTER //
// src/components/ceshi.vue